@if (vip$.store.isShowProgressBar) {
  @if (!bottomDesc()) {
    @if (vip$.store.nextVipUserLevel) {
      <div class="desc level">
        {{ 't.necessary-turnover' | translate }}
        <app-vip-level-label [levelName]="vip$.store.nextVipUserLevel?.LevelName"></app-vip-level-label>
      </div>
    }
  }
}
@if (vip$.store.nextVipUserLevel) {
  @if (vip$.store.isShowProgressBar) {
    <div class="progress-bar">
      <div class="progress" [ngStyle]="{ width: vip$.store.nextVipUserLevel?.ProgressPercent + '%' }"></div>
    </div>
    <div class="points">
      {{ vip$.store.nextVipUserLevel?.TotalReward }}
      / {{ vip$.store.nextVipUserLevel?.VPointsToReach }}
      <img src="/assets/img/vip/points.png" class="logo" />
      {{ 't.v-points' | translate }}
    </div>
  } @else {
    <div class="progress-text">
      {{ 't.catch-level-next-month' | translate }}
    </div>
  }
} @else {
  <div class="progress-text">
    {{ 't.all-levels-claimed' | translate }}
  </div>
}
